import { Repeat } from 'lucide-react';
import { FEATURE_KEYS, setFeatures, useFeatures } from '../lib/features';
import { openProfiles } from '../lib/profiles';

// branch decides the tools; single toggles only fine-tune the active branch
export default function FeatureProfile({ t, onBranch }) {
  const f = useFeatures();
  return (
    <div className="fp" data-testid="feature-profile">
      <p className="muted small-hint">{t.fpBranchHint}</p>
      <button className="btn btn-dark btn-sm" data-testid="feature-branch-btn" onClick={() => { onBranch?.(); openProfiles(); }}><Repeat size={14} /> {t.fpBranch}</button>
      <div className="fp-list">
        {FEATURE_KEYS.map((k) => (
          <label key={k} className="fp-item" data-testid={`feature-toggle-${k}`}>
            <input type="checkbox" checked={f[k] !== false} onChange={(e) => setFeatures({ [k]: e.target.checked })} /> {t['ft_' + k]}
          </label>
        ))}
      </div>
    </div>
  );
}
